<template>
  <v-content app>
    <v-container fluid>
      <v-card class="v-card---style">
        <section>
          <h2 class="mb-4">
            User Management
          </h2>
        </section>
      </v-card>
    </v-container>
  </v-content>
</template>

<style lang="scss">
  .v-card---style {
    padding: 15px 30px 30px 30px;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'

  export default {
    data() {
      return {
        is_loading: true
      }
    },
    methods: {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/UserManagement.vue